import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';
import { useTransferMoneyContext } from '../hooks/useTransferMoneyContext';

interface LinkAccounts {
  managedAccountId: string;
  itemId: string;
  accountIds: string[];
  clientId: string;
}

const linkAccounts = ({
  managedAccountId,
  itemId,
  accountIds,
  clientId,
}: LinkAccounts): Promise<string> =>
  authFetch('/Consumer/AchRelationships/Plaid', {
    method: 'POST',
    ...httpBodyOptions(
      {
        managedAccountId,
        itemId,
        accountIds,
        clientId,
      },
      true,
    ),
  });

export const useLinkAccountsMutation = () => {
  const queryClient = useQueryClient();

  const { clientId, managedAccountId } = useTransferMoneyContext();

  return useMutation(linkAccounts, {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.achRelationships(clientId, managedAccountId));
    },
  });
};
